
import { Icons } from "@ir/ui";
import { useAnalyticsScoreCards } from "@/hooks";
import AnalyticsScoreCard, { ScoreCardConfig } from "./AnalyticsScoreCard";

const CONFIG: ScoreCardConfig = {
  title: "Trade-Linked Deductions",
  theme: "success",
  icon: Icons.BarChart5,
};

const TradeLinkedDeductionsCard = () => {
  const { tradeLinkedDeductions } = useAnalyticsScoreCards();
  return <AnalyticsScoreCard config={CONFIG} data={tradeLinkedDeductions} />;
};

export default TradeLinkedDeductionsCard;
